export default "__VITE_ASSET__Ax5SB9B1__"